import { IHttpApi } from '@cian/http-api';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../state';
import { SaveSearchContent, ISaveSearchContentProps } from './SaveSearchContent';
import { makeSearch } from '../../../../filters/state/search';
import { IRequestSubscribeNewResponse, requestSubscribeNew } from '../../../../api/subscribe';
import { trackingSubscribeWithFlag, trackNewAccountRegistration } from '../../../../filters/components/save/tracking';

type TSaveSearchContentStateProps = Pick<
  ISaveSearchContentProps,
  'userEmail' | 'jsonQuery' | 'isAuthenticated' | 'showPushNotification' | 'pageHeader' | 'metaHeader'
> & { httpApi: IHttpApi };
type TSaveSearchContentDispatchProps = Pick<ISaveSearchContentProps, 'onOffersSearch'>;

export function mapStateToProps(state: IAppState): TSaveSearchContentStateProps {
  return {
    httpApi: state.httpApi,
    userEmail: state.user.isAuthenticated ? state.user.email : null,
    pageHeader: state.results.seo.h1,
    jsonQuery: state.filters.jsonQuery,
    isAuthenticated: state.user.isAuthenticated,
    showPushNotification: state.showPushNotification,
    metaHeader: state.filters.metaHeader,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TSaveSearchContentDispatchProps {
  return {
    onOffersSearch: () => dispatch(makeSearch),
  };
}

export function mergeProps(
  stateProps: TSaveSearchContentStateProps,
  dispatchProps: TSaveSearchContentDispatchProps,
): ISaveSearchContentProps {
  const { httpApi, ...otherStateProps } = stateProps;

  return {
    ...otherStateProps,
    ...dispatchProps,
    onRequestSubscribe: ({ email, title, subscribeNews, jsonQuery, notificationFrequency }) => {
      return requestSubscribeNew(httpApi, {
        email,
        title,
        jsonQuery,
        subscribeNews,
        notificationFrequency,
      }).then((res: IRequestSubscribeNewResponse) => {
        if (subscribeNews) {
          trackingSubscribeWithFlag();
        }

        if (res.auth) {
          trackNewAccountRegistration();
        }
      });
    },
  };
}

export const SaveSearchContentContainer = connect<
  TSaveSearchContentStateProps,
  TSaveSearchContentDispatchProps,
  {},
  ISaveSearchContentProps
>(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SaveSearchContent);
